import { computed, ref } from "@vue/composition-api"

const baseUrl = ref("")

export default function(){

    
    
    const setBaseUrl = (url) => {
        baseUrl.value = url
    }

    return {
        setBaseUrl,
        baseUrl: computed(() => baseUrl.value)
    }
}